module.exports = __webpack_public_path__ + "static/img/7.110d65f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/7.jpg
// module id = WIWV
// module chunks = 0